import React from 'react';
import useSWR from 'swr';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';

// — Swiper styles —
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, EffectFade, Autoplay]);

const API_URL = `${process.env.REACT_APP_API_FOLDER}list_featured_workshops/`;
const API_TOKEN = process.env.REACT_APP_API_TOKEN;
const fetcher = (url) =>
  fetch(url, { headers: { 'X-API-TOKEN': API_TOKEN } })
    .then((res) => {
      if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
      return res.json();
    });

function FeaturedWorkshops() {
  const { data: workshops, error, isLoading } = useSWR(API_URL, fetcher);

  const swiperParams = {
    slidesPerView: 1,
    speed: 1500,
    loop: true,
    centeredSlides: true,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    navigation: {
      nextEl: '.hero-next3',
      prevEl: '.hero-prev3',
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.hero-two-pagination',
      clickable: true,
      renderBullet: (idx, className) => `<span class="${className}">0${idx + 1}</span>`,
    },
    observer: true,
    observeParents: true,
  };

  if (isLoading) {
    return (
      <div className="hero-area hero-style-four">
        <div className="hero-main-wrapper position-relative">
          <div className="container">
            {[1, 2, 3].map((idx) => (
              <Skeleton key={idx} height={400} style={{ marginBottom: '1rem' }} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="hero-area hero-style-four">
      <div className="hero-main-wrapper position-relative">
        <Swiper {...swiperParams} className="hero-slider-four">
          {workshops.map((ws) => {
            const tutorClasses = [
              'txt-gradient-1',
              'txt-gradient-2',
              'txt-gradient-3',
              'txt-gradient-4',
              'txt-gradient-5',
              'txt-gradient-6',
            ];
            const randCls = tutorClasses[Math.floor(Math.random() * tutorClasses.length)];

            return (
              <SwiperSlide key={ws.short_url}>
                <div
                  className="slider-bg-1"
                  style={{ backgroundImage: `url(${ws.course_image})` }}
                >
                  <div className="container">
                    <div className="row justify-content-lg-start justify-content-center align-items-center">
                      <div className="col-xl-7 col-lg-7">
                        <div className="hero4-content">
                          <h1 className={ws.title_class}>
                            {ws.title_with}{' '}
                            <span className={randCls}>{ws.tutors}</span>
                          </h1>
                          <p>
                            {ws.short_description}{' '}
                            <span className="featuredPlaces">
                              {ws.places} {ws.placesword}
                            </span>
                          </p>
                          <Link
                            to={`${ws.ctype}/${ws.short_url}`}
                            className="button-fill-primary all-package-btn"
                            onClick={() => window.scrollTo(0, 0)}
                          >
                            Read more
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
          <div className="hero-two-pagination" />
        </Swiper>

        <div className="slider-arrows text-center d-lg-flex flex-column d-none gap-5">
          <div className="hero-prev3" tabIndex={0} role="button" aria-label="Previous slide">
            <i className="bi bi-arrow-left" />
          </div>
          <div className="hero-next3" tabIndex={0} role="button" aria-label="Next slide">
            <i className="bi bi-arrow-right" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedWorkshops;